// ----------
// Haudi Encryption Liblary
//
// 2022/10/6
// Created by Kazunori Asada
// Modified by Shotaro Ito
// AES-128-CBC、パディングなし。

//const kHaudiKey = "Haudi21563210601";
//const kHaudiIv  = "Kiyota7134960620";

const CryptoJS = require("crypto-js");

export function aesEncryptWithStringKey(
  keyString: string,
  ivString: string,
  plain: any,
) {
  const key = string2bytes(keyString.substr(0, 16));
  // console.log("aesEncryptFromStringWithStringKey - keyString: " + keyString + ", key: ", hexs2hex(bytes2hexs(key)));
  const iv = string2bytes(ivString.substr(0, 16));
  // console.log("aesEncryptFromStringWithStringKey - ivString: " + ivString + ", iv: ", hexs2hex(bytes2hexs(iv)));
  const encrypted = aesEncrypt(key, iv, plain);
  return encrypted;
}

export function aesDecryptWithStringKey(
  keyString: string,
  ivString: string,
  encrypted: any,
) {
  const key = string2bytes(keyString);
  // console.log("aesDecryptWithStringKey - keyString: " + keyString + ", key: ", hexs2hex(bytes2hexs(key)));
  const iv = string2bytes(ivString);
  // console.log("aesDecryptWithStringKey - ivString: " + ivString + ", iv: ", hexs2hex(bytes2hexs(iv)));
  const decrypted = aesDecrypt(key, iv, encrypted);
  return decrypted;
}

export function aesEncrypt(key: any, iv: any, plainBytes: any) {
  const keyHex = CryptoJS.enc.Hex.parse(
    hexs2hex(bytes2hexs(key)).substr(0, 32),
  );
  const ivHex = CryptoJS.enc.Hex.parse(hexs2hex(bytes2hexs(iv)).substr(0, 32));
  // console.log("aesEncrypt - keyHex: " + keyHex);
  // console.log("aesEncrypt - ivHex: " + ivHex);

  const plainHex = CryptoJS.enc.Hex.parse(hexs2hex(bytes2hexs(plainBytes)));
  // console.log("aesEncrypt - plainHex: " + plainHex);

  const encrypted = CryptoJS.AES.encrypt(plainHex, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding,
  });
  const encryptedHex = encrypted.ciphertext.toString();
  // console.log("aesEncrypt - encryptedHex: " + encryptedHex);

  const encryptedBytes = hexs2bytes(hex2hexs(encryptedHex));
  return encryptedBytes;
}

export function aesDecrypt(key: any, iv: any, encryptedBytes: any) {
  const keyHex = CryptoJS.enc.Hex.parse(
    hexs2hex(bytes2hexs(key)).substr(0, 32),
  );
  const ivHex = CryptoJS.enc.Hex.parse(hexs2hex(bytes2hexs(iv)).substr(0, 32));
  // console.log("aesDecrypt - keyHex: " + keyHex);
  // console.log("aesDecrypt - ivHex: " + ivHex);

  const encryptedHex = CryptoJS.enc.Hex.parse(
    hexs2hex(bytes2hexs(encryptedBytes)),
  );
  const encryptedBase64 = encryptedHex.toString(CryptoJS.enc.Base64);
  // console.log("aesDecrypt - encryptedHex: " + encryptedHex);
  // console.log("aesDecrypt - encryptedBase64: " + encryptedBase64);

  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding,
  });
  const decryptedHex = decrypted.toString(CryptoJS.enc.Hex);
  // console.log("aesDecrypt - decryptedHex: " + decryptedHex);

  const decryptedBytes = hexs2bytes(hex2hexs(decryptedHex));
  return decryptedBytes;
}

export function sha512Hash(data: any) {
  var digest = CryptoJS.enc.Hex.stringify(CryptoJS.SHA512(data));
  // console.log("sha512Hash - digest: " + digest);
  return digest;
}

export function sha256Hash(data: any) {
  var digest = CryptoJS.enc.Hex.stringify(CryptoJS.SHA256(data));
  // console.log("sha256Hash - digest: " + digest);
  return digest;
}

export function sha1Hash(data: any) {
  var digest = CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(data));
  // console.log("sha1Hash - digest: " + digest);
  return digest;
}

export function md5Hash(data: string) {
  var digest = CryptoJS.enc.Hex.stringify(CryptoJS.MD5(data));
  // console.log("md5Hash - digest: " + digest);
  return digest;
}

/*
 * string -> byte[] -> hex[] -> hex
 * hex -> hex[] -> byte[] -> string
 */

// string -> byte[]
export function string2bytes(str: string) {
  var bytes = str.split("").map((char) => char.charCodeAt(0));
  return bytes;
}

// byte[] -> hex[]
export function bytes2hexs(bytes: any[]) {
  var hexs = bytes.map((byte) => byte.toString(16).padStart(2, "0"));
  return hexs;
}

// hex[] -> hex
export function hexs2hex(hexs: any[]) {
  var hex = hexs.join("");
  return hex;
}

// hex -> hex[]
export function hex2hexs(hex: string) {
  var hexs = [];
  for (var i = 0; i < hex.length; i += 2) {
    hexs.push(hex.substr(i, 2));
  }
  return hexs;
}

// hex[] -> byte[]
export function hexs2bytes(hexs: any[]) {
  var bytes = hexs.map((hex) => parseInt(hex, 16));
  return bytes;
}

// byte[] -> string
export function bytes2string(bytes: any[]) {
  var string = bytes.map((byte) => String.fromCharCode(byte)).join("");
  return string;
}
